import request from "@/utils/request";

// 登录方法
export function login(data) {
  return request({
    url: "/api/oper/login",
    method: "post",
    data: data,
  });
}
// 修改密码
export function changePass(data) {
  return request({
    url: "/api/oper/changePass",
    method: "post",
    data: data,
  });
}
